// extracted by mini-css-extract-plugin
module.exports = {"button1":"buttonEndGame_button1__3aG83","body":"buttonEndGame_body__1wUx2"};